const oFeedSectionInfo = {
  oFeedSectionInfo: {
    products: 'Productos',
    projects: 'Formaciones',

    actions: {
      goBack: 'volver atrás'
    }
  }
}

export default oFeedSectionInfo
